import React from "react";
import Collapse from "@mui/material/Collapse";
import "./GuideCollapse.css";

export default function GuideCollapse({ open }) {
  const steps = [
    {
      step: "01",
      title: "Enter the Invoice Details",
      desc: "Click “Generate Invoice” and fill in the Invoice Number and Date, then click Submit.",
      color: "#2E90FA",
      bgColor: "#F0F9FF",
      borderColor: "#B2DDFF",
    },
    {
      step: "02",
      title: "Download  Invoice",
      desc: 'After submission, the system will create the pdf invoice. Download the PDF after it is generated if you want',
      color: "#12B76A",
      bgColor: "#ECFDF3",
      borderColor: "#A6F4C5",
    },
    {
      step: "03",
      title: "Upload  Invoice",
      desc: " Upload the signed invoice copy using the upload option shown.",
      color: "#F97316",
      bgColor: "#FFF6ED",
      borderColor: "#FEC89F",
    },
    {
      step: "04",
      title: "Confirm Upload",
      desc: "Click Yes on the confirmation popup and get a success message for successful upload.",
      color: "#9E77ED",
      bgColor: "#F9F5FF",
      borderColor: "#E9D7FE",
    },
  ];

  return (
    <Collapse in={open} timeout={500} unmountOnExit>
      <div className="guide-container">
        <h3 className="guide-heading">📄 Invoice Upload Process</h3>
        <p className="guide-subheading">
          Follow these simple steps to complete your invoice upload
        </p>
        <div className="guide-cards-wrapper">
          {steps.map((step, index) => (
            <div
              key={index}
              className="guide-card animate-step"
              style={{
                animationDelay: `${index * 300}ms`,
                backgroundColor: step.bgColor,
                border: `1px solid ${step.borderColor}`,
              }}
            >
              <div
                className="guide-step-circle"
                style={{ backgroundColor: step.color }}
              >
                {step.step}
              </div>
              <div className="guide-card-title">{step.title}</div>
              <div className="guide-card-desc">{step.desc}</div>

              {index < steps.length - 1 && (
                <div className="guide-connector">
                  <div className="guide-connector-line" />
                  <div className="guide-connector-circle">→</div>
                  <div className="guide-connector-line" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </Collapse>
  );
}
